import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import dark from './dark';
import light from './light';
export default {
  dark: dark,
  light: light
};

if (typeof light !== 'undefined' && light && light === Object(light) && Object.isExtensible(light) && !light.hasOwnProperty('__filemeta')) {
  Object.defineProperty(light, '__filemeta', {
    configurable: true,
    value: {
      name: "light",
      filename: "node_modules/gatsby-theme-docz/src/theme/prism/index.js"
    }
  });
}

if (typeof dark !== 'undefined' && dark && dark === Object(dark) && Object.isExtensible(dark) && !dark.hasOwnProperty('__filemeta')) {
  Object.defineProperty(dark, '__filemeta', {
    configurable: true,
    value: {
      name: "dark",
      filename: "node_modules/gatsby-theme-docz/src/theme/prism/index.js"
    }
  });
}